import React from 'react'
import InfoIcon from 'transfix-icons/build/InfoIcon'
import { makeStyles } from 'transfix-ui/core'
import { brandColors, Tooltip } from 'transfix-ui'
import { formatCustomerQuote } from '../utils/formatHistoricalQuotesTableContents'

interface ISubmittedQuoteCellProps {
  customerQuote?: number | null
  customerQuoteType?: string | null
  allInQuote?: number | null
  isDoNotBidApplied?: boolean | null
  linehaulQuote?: number | null
  numberOfDecimals?: number
}

const useStyles = makeStyles(() => ({
  noQuote: {
    color: brandColors.coolGray4,
  },
  quote: {
    color: brandColors.coolGray7,
  },
  align: {
    display: 'inline-block',
    verticalAlign: 'middle',
    paddingLeft: '4px',
  },
}))
const NO_QUOTE_DNB_IS_PRESENT =
  '"No Quote Record" could mean that a quote was manually generated but not submitted in SQT, or that Transfix did not bid in response to this request due to autobidder logic or an error.'
const NO_QUOTE_DNB_IS_NULL =
  '"No Quote Record" could mean that a quote was manually generated but not submitted in SQT, or that Transfix did not bid in response to this request due to autobidder logic, a Do Not Bid rule, or an error'

export const SubmittedQuoteCell = ({
  allInQuote,
  customerQuote,
  customerQuoteType,
  isDoNotBidApplied,
  linehaulQuote,
  numberOfDecimals = 2,
}: ISubmittedQuoteCellProps) => {
  const classes = useStyles()
  const tooltipMessage = isDoNotBidApplied !== null ? NO_QUOTE_DNB_IS_PRESENT : NO_QUOTE_DNB_IS_NULL

  if (isDoNotBidApplied) {
    return <div className={classes.quote}>Do Not Bid</div>
  }
  if (!customerQuote) {
    return (
      <div className={classes.noQuote}>
        No Quote Record
        <span className={classes.align}>
          <Tooltip position='top' effect='solid' trigger={<InfoIcon size='medium' />}>
            {tooltipMessage}
          </Tooltip>
        </span>
      </div>
    )
  }
  const typeOfQuote = formatCustomerQuote(
    customerQuote,
    customerQuoteType,
    allInQuote,
    linehaulQuote
  )

  return (
    <div>
      <div>${customerQuote.toFixed(numberOfDecimals)}</div>
      <div className={classes.quote}>{typeOfQuote}</div>
    </div>
  )
}
